import { format as dfFormat } from "date-fns";

/**
 * Render an ISO/UTC timestamp in the user's local time zone using a
 * fixed, uniform visual format: `dd/MM/yyyy, HH:mm:ss`.
 *
 * The format is identical across browsers and locales — only the
 * displayed clock time shifts to whatever time zone the user is in.
 */
export const formatLocalDateTime = (isoString) => {
  if (!isoString) return "";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return String(isoString);
  return dfFormat(d, "dd/MM/yyyy, HH:mm:ss");
};
